module.exports = __webpack_public_path__ + "img/auto-sliding-carousel-fullscreen2.b4ee9441.png";